import {customElement} from "lit/decorators.js";
import {DialogAnchorTemplateContent} from "./dialogAnchorTemplateContent";


@customElement("eop-download-dialog")
export class EopDownloadDialog extends DialogAnchorTemplateContent {

    public connectedCallback(): void {
        super.connectedCallback();

        if (!this.dialogContent) {
            return;
        }

        this.dialogContent.classList.add("download-dialog");

        if (this.dialogContent.classList.contains("lightbox-image")) {
            this.addEventListener("click", event => {
                const isClickOnImage = event.target === this.querySelector("img") || (event.target as HTMLElement).classList.contains("lightbox-image-preview-icon");
                if (isClickOnImage) {
                    event.preventDefault();
                    this.openDialog(event);
                }
            });
        } else if (this.dialogContent.classList.contains("disclaimer-dialog")) {
            this.addEventListener("click", event => {
                const isClickOnImageOrLabel = event.target === this.querySelector("img") || (event.target as HTMLElement).classList.contains("download-label");
                if (isClickOnImageOrLabel) {
                    event.preventDefault();
                    this.openDialog(event);
                }
            });
        }
    }

}
